module.exports = __webpack_public_path__ + "static/media/AlanPresidentsAward.4149615f.png";